import React from 'react';

export default function Terms() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Términos y Condiciones – Casa Gloria, México</h1>
      <p>
        Al completar tu reservación, aceptas los siguientes términos:
      </p>
      <ul className="list-disc ml-5 mt-3 space-y-2">
        <li>Todas las reservaciones son <strong>no reembolsables</strong>.</li>
        <li>Check-in: 3:00 PM | Check-out: 12:00 PM.</li>
        <li>Se requiere una identificación válida al momento del check-in (INE o pasaporte).</li>
        <li>Los huéspedes son responsables por cualquier daño o pérdida ocasionada durante su estancia.</li>
        <li>Se permiten mascotas únicamente si fueron incluidas en la reservación.</li>
        <li>Está estrictamente prohibido fumar dentro de las habitaciones.</li>
        <li>Casa Gloria se reserva el derecho de realizar cargos por daños o incumplimiento de normas.</li>
      </ul>
      <p className="mt-4">Gracias por elegir Casa Gloria. ¡Esperamos que disfrutes tu estancia!</p>
    </div>
  );
}
